<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS - Pendências</span>
                </h4>
                <filtros
                    tiposFiltros="n"
                    @filtroAtualizado="filtro = $event"
                ></filtros>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <!-- <b-button
                    variant="success"
                    @click.stop="emitirRelatorio(1)"
                    class="ml-2">
                    <span>
                        <i class="fa fa-table mr-2"></i> Emitir Relatório XLSX
                    </span>
                </b-button> -->
                <b-button
                    variant="primary"
                    @click.stop="emitirRelatorio(2)"
                    class="ml-2">
                    <span>
                        <i class="fa fa-file mr-2"></i> Emitir Relatório PDF
                    </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Filtros from './Filtros'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        Filtros
    },

    data() {
        return {
            filtro: {
                convenio: null,
                pdf: false,
                excel: false
            }
        }
    },

    methods: {
        emitirRelatorio(codigo) {
            this.$store.dispatch('addRequest')
            if(codigo == 1)
            {
                this.filtro.excel = true;
            } else if (codigo == 2)
            {
                this.filtro.pdf = true;
            }
            RelatoriosServicos.emitirRelatorio('pendencias', this.filtro).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        if(codigo == 1){
                            this.$download(response, 'ConvenioPendencias.xlsx')
                            this.filtro.excel = false;
                        } else if (codigo == 2){
                            this.$download(response, 'ConvenioPendencias.pdf')
                            this.filtro.pdf = false;
                        }
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch: {
        filtro() {}
    }
}
</script>
